var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 120,
    viewBox: "0 0 195 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_76310)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0293 67.6487C16.9859 51.0572 30.7287 35.998 43.5397 25.1413C58.0744 12.7962 76.1029 3.77812 95.5294 0.757521C111.974 -1.78154 127.906 2.15838 140.764 11.1326C144.584 13.8031 148.171 16.9112 151.386 20.4133C155.112 24.4846 158.513 29.125 161.308 34.1156C166.899 43.9654 170.206 55.1722 169.461 66.0289C169.134 71.1946 168.11 76.3605 166.433 81.3067C162.333 93.039 154.181 103.152 143.699 110.55C140.158 113.045 136.152 115.234 131.866 116.898C122.875 120.4 112.719 121.451 103.868 117.335C93.7594 112.607 89.4266 99.3435 77.8736 97.548C72.283 96.6727 66.8325 98.949 61.382 100.35C50.8071 103.064 36.319 104.465 27.5143 97.6357C17.8711 90.1935 13.6783 79.1182 15.0293 67.6487Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.25 103.152C194.25 107.972 190.564 111.795 186.017 111.795C185.938 111.795 185.232 111.795 180.372 111.795C176.922 111.795 171.433 111.795 162.73 111.795H158.574C153.086 111.961 148.695 107.307 148.695 101.656C148.695 96.0049 153.086 91.3511 158.653 91.6009C163.436 75.8111 185.232 78.0544 187.114 94.3429C191.192 95.0081 194.25 98.6644 194.25 103.152Z",
    fill: "url(#paint0_linear_382_76310)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.017 111.878C190.564 111.878 194.25 107.972 194.25 103.235C194.25 98.4145 190.564 94.5918 186.017 94.5918C181.47 94.5918 177.784 98.4978 177.784 103.235C177.784 107.972 181.47 111.878 186.017 111.878Z",
    fill: "url(#paint1_linear_382_76310)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.609 111.961C180.685 111.961 187.272 105.063 187.272 96.5034C187.272 87.9437 180.685 81.0459 172.609 81.0459C164.534 81.0459 157.947 87.9437 157.947 96.5034C157.947 104.98 164.455 111.961 172.609 111.961Z",
    fill: "url(#paint2_linear_382_76310)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 37.5707C51.75 43.0835 47.5729 47.4815 42.4094 47.4815C42.2934 47.4815 41.5392 47.4815 35.9697 47.4815C32.0827 47.4815 25.875 47.4815 15.9543 47.4815H11.1971C4.98935 47.6053 0 42.3402 0 35.8982C0 29.4562 4.98935 24.1292 11.3131 24.439C16.7085 6.41382 41.5392 8.95342 43.6278 27.598C48.269 28.2174 51.75 32.4295 51.75 37.5707Z",
    fill: "url(#paint3_linear_382_76310)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4089 47.4817C47.5723 47.4817 51.7494 43.0218 51.7494 37.571C51.7494 32.12 47.5723 27.6602 42.4089 27.6602C37.2455 27.6602 33.0684 32.12 33.0684 37.571C33.0684 43.0218 37.2455 47.4817 42.4089 47.4817Z",
    fill: "url(#paint4_linear_382_76310)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1514 47.6047C36.3179 47.6047 43.802 39.6761 43.802 29.8893C43.802 20.1025 36.3179 12.1738 27.1514 12.1738C17.985 12.1738 10.501 20.1025 10.501 29.8893C10.501 39.6761 17.927 47.6047 27.1514 47.6047Z",
    fill: "url(#paint5_linear_382_76310)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5406 99.7755C122.395 99.7755 140.923 81.2475 140.923 58.3112C140.923 35.3751 122.313 16.8467 99.5406 16.8467C76.6858 16.8467 58.1572 35.3751 58.1572 58.3112C58.1572 81.2475 76.6858 99.7755 99.5406 99.7755Z",
    fill: "#EAEEF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.229 31.1306C140.078 31.1306 141.577 29.6323 141.577 27.7841C141.577 25.9358 140.078 24.4375 138.229 24.4375C136.381 24.4375 134.883 25.9358 134.883 27.7841C134.883 29.6323 136.381 31.1306 138.229 31.1306Z",
    fill: "#EAEEF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.127 18.0709C144.389 18.0709 145.413 17.0477 145.413 15.7855C145.413 14.5232 144.389 13.5 143.127 13.5C141.865 13.5 140.842 14.5232 140.842 15.7855C140.842 17.0477 141.865 18.0709 143.127 18.0709Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3616 31.0494C61.6239 31.0494 62.6471 30.0262 62.6471 28.764C62.6471 27.5017 61.6239 26.4785 60.3616 26.4785C59.0994 26.4785 58.0762 27.5017 58.0762 28.764C58.0762 30.0262 59.0994 31.0494 60.3616 31.0494Z",
    fill: "#EAEEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7444 80.4536C53.0885 80.4536 54.9888 78.5531 54.9888 76.2094C54.9888 73.8651 53.0885 71.9648 50.7444 71.9648C48.4003 71.9648 46.5 73.8651 46.5 76.2094C46.5 78.5531 48.4003 80.4536 50.7444 80.4536Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_382_76310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.567 85.3669H66.5133C63.4764 85.3669 61.0088 82.8994 61.0088 79.8626V37.5348C61.0088 34.4978 63.4764 32.0303 66.5133 32.0303H132.567C135.604 32.0303 138.072 34.4978 138.072 37.5348V80.0524C137.881 82.8994 135.414 85.3669 132.567 85.3669Z",
    fill: "url(#paint6_linear_382_76310)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53.25H123.75",
    stroke: "#939DAE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63.75H110.25",
    stroke: "#939DAE",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.029 39.7911H60.7793V35.8479C60.7793 33.7867 62.3898 32.084 64.3395 32.084H134.44C136.39 32.084 138 33.7867 138 35.8479V39.7911H126.048H115.029Z",
    fill: "#D5DDEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3566 37.3716C66.0121 37.3716 66.5434 36.8098 66.5434 36.1169C66.5434 35.424 66.0121 34.8623 65.3566 34.8623C64.7012 34.8623 64.1699 35.424 64.1699 36.1169C64.1699 36.8098 64.7012 37.3716 65.3566 37.3716Z",
    fill: "#989FB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7472 37.3716C69.4026 37.3716 69.9339 36.8098 69.9339 36.1169C69.9339 35.424 69.4026 34.8623 68.7472 34.8623C68.0918 34.8623 67.5605 35.424 67.5605 36.1169C67.5605 36.8098 68.0918 37.3716 68.7472 37.3716Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2229 37.3716C72.8782 37.3716 73.4095 36.8098 73.4095 36.1169C73.4095 35.424 72.8782 34.8623 72.2229 34.8623C71.5674 34.8623 71.0361 35.424 71.0361 36.1169C71.0361 36.8098 71.5674 37.3716 72.2229 37.3716Z",
    fill: "#989FB0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.135 93.3664C111.871 94.4846 111.477 95.6696 111.016 96.6566C109.765 99.0919 107.791 101.001 105.356 102.251C102.856 103.501 99.8939 104.028 96.9322 103.37C89.9564 101.922 85.4812 95.0771 86.9294 88.1014C88.3769 81.1256 95.1554 76.5844 102.132 78.0979C104.632 78.6244 106.804 79.8746 108.647 81.5861C111.74 84.6791 113.056 89.1544 112.135 93.3664Z",
    fill: "url(#paint7_linear_382_76310)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_382_76310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 78,
    width: 27,
    height: 26
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5738 103.611L112.302 90.8828L99.5738 78.1549L86.8459 90.8828L99.5738 103.611Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_382_76310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7402 87.1708H105.408M105.408 87.1708L103.286 85.0498M105.408 87.1708L103.286 89.2926M95.862 92.4741L93.7402 94.5958M93.7402 94.5958L95.862 96.7168M93.7402 94.5958H105.408",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_382_76310",
    x: 39.0088,
    y: 21.0303,
    width: 121.063,
    height: 97.3369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_382_76310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_382_76310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_382_76310",
    x1: 171.482,
    y1: 93.7369,
    x2: 171.465,
    y2: 112.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECEFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_382_76310",
    x1: 176.923,
    y1: 92.6013,
    x2: 184.686,
    y2: 100.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BECADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_382_76310",
    x1: 156.424,
    y1: 89.7309,
    x2: 168.096,
    y2: 94.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_382_76310",
    x1: 25.8843,
    y1: 26.7814,
    x2: 25.8651,
    y2: 47.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECEFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_382_76310",
    x1: 32.0643,
    y1: 25.4828,
    x2: 40.9479,
    y2: 34.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BECADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_382_76310",
    x1: 8.7807,
    y1: 22.1971,
    x2: 22.0622,
    y2: 27.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_382_76310",
    x1: 99.5152,
    y1: 30.7966,
    x2: 99.5152,
    y2: 85.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_382_76310",
    x1: 86.6452,
    y1: 90.7331,
    x2: 112.429,
    y2: 90.7331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_76310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194.25,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEmptyState);
export default __webpack_public_path__ + "static/media/tableEmptyState.4ad82af634bfa54d802f0513d835a049.svg";
export { ForwardRef as ReactComponent };